<template
    ><v-card flat>
        <v-overlay :value="loadingCompanyData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ activeCompany.name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark color="bal-red" @click="editProduct">
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>
            <v-menu offset-y bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteClick">
                        <v-list-item-title style="color: red">{{ "Delete" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "General info" | t }}
            </v-tab>
            <v-tab-item>
                <general-info-view-tab />
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Integration info" | t }}
            </v-tab>
            <v-tab-item>
                <integration-info-view-tab />
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Contact info" | t }}
            </v-tab>
            <v-tab-item>
                <contact-info-view-tab />
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "UI configuration" | t }}
            </v-tab>
            <v-tab-item>
                <ui-configurations-view-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import GeneralInfoViewTab from "./tabs/general-info-view-tab";
import IntegrationInfoViewTab from "./tabs/integration-info-view-tab";
import Store from "../../store";
import ContactInfoViewTab from "./tabs/contact-info-view-tab";
import UiConfigurationsViewTab from "@/views/company/tabs/ui-configurations-view-tab.vue";

export default {
    name: "company-view",
    components: {UiConfigurationsViewTab, ContactInfoViewTab, IntegrationInfoViewTab, GeneralInfoViewTab },
    data() {
        return {
            tab: 0,
            tabs: ["General info", "Integration info", "Contact info", "UI configuration"]
        };
    },
    computed: {
        ...mapState(["activeCompany", "loadingCompanyData", "activeCompanyBanks"])
    },
    mounted() {
        document.addEventListener("keydown", this.nextTab);
        Store.dispatch("getCompanyData", this.$route.params.companyId);
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    methods: {
        closeDrawer() {
            this.$router.push({ name: "companies-list" });
        },
        editProduct() {
            this.$router.push({
                name: "company-edit",
                params: { companyId: this.$route.params.companyId, tab: this.tabs[this.tab] }
            });
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editProduct();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        },
        async handleDeleteClick() {
            if (confirm("Are you sure you want to delete this company?")) {
                const response = await Store.dispatch("deleteCompany", {
                    company_id: this.activeCompany.id
                });
                if (response && response.status === 1) {
                    await this.$router.push({
                        name: "companies-list"
                    });
                    await Store.dispatch("getCompanies");
                    await Store.commit("setRequestSuccess", true);
                } else {
                    await Store.commit("setRequestError", true);
                    await Store.commit("setErrorMessage", "Failed");
                }
            }
        }
    }
};
</script>

<style scoped></style>
